import { useEffect, useState } from "react";
import { adapter } from "@/services/db";
import { text } from "@/lib/format";

// Best-effort customer identity from users doc, then the linked request (public + private/contact).
export const custLabel = (u, req) =>
  text(u?.name || u?.full_name || u?.display_name || req?.customer_name || req?.service_address?.contact?.name, null);
export const custPhone = (u, req) => text(u?.phone || req?.customer_phone || req?.service_address?.contact?.phone, null);

export function usePrivateContact(requestId) {
  const [c, setC] = useState(null);
  useEffect(() => {
    setC(null);
    if (!requestId) return undefined;
    return adapter.subscribeDoc(`requests/${requestId}/private`, "contact", setC);
  }, [requestId]);
  return c;
}
